// Children helpers copied from the hybrid app (apps/web components/DataGrid + dialogs/ChildrenDialog), without the UI.
import { otherParty, type Child, type PartyIndex } from '@divorceos/schema';
import { childNcpPercent } from './timeshare';

/** Average % of time the other parent's children spend with `party` (this party as the NCP). */
export function ncpPercentFor(children: Child[], fallback: number, party: PartyIndex): number {
  const kids = children.filter((ch) => ch.custodialParent === otherParty(party));
  if (kids.length === 0) return children.length === 0 ? fallback : 0;
  return kids.reduce((a, ch) => a + childNcpPercent(ch), 0) / kids.length;
}

/** Keep the per-party summary fields (children count, timeshare as NCP) in step with the children list. */
export function syncPartiesFromChildren(c: { children: Child[]; parties: [{ childrenAsCustodial: number; timeWithNcpPercent: number }, { childrenAsCustodial: number; timeWithNcpPercent: number }] }): void {
  for (const p of [0, 1] as PartyIndex[]) {
    c.parties[p].childrenAsCustodial = c.children.filter((ch) => ch.custodialParent === p).length;
    const asNcp = c.children.filter((ch) => ch.custodialParent === otherParty(p));
    c.parties[p].timeWithNcpPercent = asNcp.length === 0 ? 0 : asNcp.reduce((a, ch) => a + childNcpPercent(ch), 0) / asNcp.length;
  }
}

/** Average share of the children's time with `party`, percent (0 when there are no children). */
export function timeshareWith(children: Child[], party: PartyIndex): number {
  if (children.length === 0) return 0;
  return children.reduce((a, ch) => a + (ch.custodialParent === party ? 100 - childNcpPercent(ch) : childNcpPercent(ch)), 0) / children.length;
}
